import React from 'react';
import CountryManagerTable from '../../../components/LocaleMasters/CountryManager/CountryManagerTable';
import ContentView from '../../../components/Layouts/ContentView';
const index = () => {
    return (
        <ContentView>
            <CountryManagerTable />
        </ContentView>
    );
};
export default index;
